import TwitterIcon from 'components/Icons/Twitter'
import NumberIcon from 'components/NumberIcon'
import { range } from 'lodash'
import {
  TbArrowsSplit2,
} from 'react-icons/tb'
import styles from './ContentScheduleDiagram.module.css'

type TwitterThreadDiagramProps = {
  index?: number,
  count: number,
}

// const threadIndexColors = [
//   // '!text-purple-600/50 !border-purple-600/50',
//   'mb-1 !text-sky-600/50 !border-sky-600/50',
//   'mb-1 !text-sky-600/50 !border-sky-600/50',
//   // '!text-green-600/50 !border-green-600/50',
// ]

const numberGreen = '!text-emerald-600/50 !border-emerald-600/50'
const numberBlue = '!text-sky-600/50 !border-sky-600/50'

const TwitterThreadDiagram = ({ index, count }: TwitterThreadDiagramProps) =>
  <div className='flex flex-col w-10 items-center'>
    { !!index && <NumberIcon className={`mb-1 ${
      index <= 3
        ? numberGreen
        : numberBlue
    }`}>{ `${index}` }</NumberIcon> }
    <TwitterIcon width={32} height={32} />
    <div className='flex flex-col relative -left-2 top-1 justify-center'>
      { range(count || 0).map((id: number) =>
        <div key={id} className='-mt-[7px] relative odd:left-[14px]'>
          <TwitterIcon className='stroke-gray-100 stroke-[120]' />   {/* fill='white' className='stroke-sky-400 stroke-[120]' */}
        </div>
      ) }
    </div>
  </div>

const ContentScheduleDay = ({ day, isLastDay = false, children }: { day: number, isLastDay?: boolean, children: React.ReactNode }) => <div className='flex flex-col items-center'>
  <div className={`uppercase text-[.7rem] py-0 px-3 text-white rounded-full whitespace-nowrap mb-3 -ml-4 relative ${ day <= 2 ? 'bg-emerald-500' : 'bg-sky-800'} ${ day === 7 ? 'left-2' : ''}`}>
    Day { day }
    { day <= 2 && <div className='absolute bottom-[130%] left-0 right-0 text-emerald-500 text-center font-bold'>FREE!</div> }
  </div>
  <div className='flex flex-row'>
    { children }
    { !isLastDay && <div className='w-px h-32 mb-2 border-r border-gray-200 ml-4' /> }
  </div>
</div>

const ContentScheduleDiagram = () => <div className='font-[Montserrat]'>
  <div className='w-full mt-8 text-base text-gray-500'>
    <div className='flex justify-between'>
      <div>Example Tweet and Thread Content Schedule</div>
    </div>
    <div className='text-gray-400 text-sm'>Count of threads (vs standalone Tweets) and number of replies vary based on blog post content</div>
  </div>
  <div className={styles.contentScheduleDiagram}>
    <ContentScheduleDay day={1}>
      <TwitterThreadDiagram index={1} count={4} />
    </ContentScheduleDay>
    <ContentScheduleDay day={2}>
      <TwitterThreadDiagram index={2} count={0} />
      {/* <TwitterIcon width={32} height={32} /> */}
      <TwitterThreadDiagram index={3} count={8} />
    </ContentScheduleDay>
    <ContentScheduleDay day={3}>
      <TwitterThreadDiagram index={4} count={2} />
    </ContentScheduleDay>
    <ContentScheduleDay day={4}>
      <TwitterThreadDiagram index={5} count={0} />
      {/* <TwitterIcon width={32} height={32} /> */}
    </ContentScheduleDay>
    <ContentScheduleDay day={5}>
      <TwitterThreadDiagram index={6} count={3} />
    </ContentScheduleDay>
    <ContentScheduleDay day={6}>
      <TwitterThreadDiagram index={7} count={7} />
      <TwitterThreadDiagram index={8} count={0} />
      {/* <TwitterIcon width={32} height={32} /> */}
    </ContentScheduleDay>
    <ContentScheduleDay day={7} isLastDay>
      <TwitterThreadDiagram index={9} count={5} />
    </ContentScheduleDay>
    <div className='text-xs flex md:flex-col gap-2 md:gap-1 items-center md:absolute md:top-4 right-0 md:left-full w-48 h-32 md:w-24 rounded-xl text-gray-600 md:flex-nowrap justify-between border-2 md:border-0 border-slate-300 pr-4'>
      <div className='uppercase text-xs md:text-[10px] font-bold bg-gray-300 md:bg-transparent text-slate-700 h-full w-12 flex rounded-l-lg md:rounded-none items-center justify-center'>
        <div>Key</div>
      </div>
      <div className='flex flex-col gap-px items-center mr-1 mb-2 h-[98px] justify-between'>
        <TwitterIcon width={32} height={32} className='md:relative top-1' />
        <div className='mt-1 text-center'>Single<br />Tweet</div>
      </div>
      <div className='flex flex-col gap-px items-center h-[98px] justify-between mb-2 mr-1'>
        <TwitterThreadDiagram count={2} />
        <div className='mt-1 text-center'>Twitter<br />Thread</div>
      </div>
    </div>
  </div>
    {/* <div className='text-xs flex gap-2 items-center absolute bottom-0 right-4'>
      <div className='uppercase'>Key: </div>
      <div className='flex gap-px items-center mr-1'>
        <TwitterIcon width={32} height={32} />
        <div>Tweet</div>
      </div>
      <div className='flex gap-px items-center'>
        <TwitterIcon width={20} height={20} />
        <div>In-Thread Tweet Reply</div>
      </div>
    </div>
  </div> */}
  <div className='md:-ml-4 w-full mb-12 text-sm text-gray-500 flex'>
    <div className='w-full flex gap-5 items-center justify-between pl-6 pr-0 py-3 md:pr-8 md:pl-8 bg-gray-50 md:rounded-b-xl md:shadow-md relative
    border-t border-gray-200 md:border md:border-t-slate-200 text-sky-700'>
      <div className='w-24 h-24 flex justify-center items-center bg-white border-4 border-slate-300 rounded-full'>
        <div>
          <TbArrowsSplit2 size={50} className='relative stroke-slate-300' />
          <TbArrowsSplit2 size={50} className='relative -mt-[40px] ml-3 stroke-emerald-200' />
          <TbArrowsSplit2 size={50} className='relative -mt-[40px] stroke-slate-400 z-10' />
        </div>
      </div>
      <div className='w-52 py-2 pr-3 bg-transparent
      border-r-sky-700 border-r'>Tweets from several blog posts are interwoven for a more natural cadence</div>
      <div className='flex flex-col gap-4 md:gap-1'>
        <div>Tweets&nbsp;
          <NumberIcon className={numberGreen}>1</NumberIcon>&nbsp;
          <NumberIcon className={numberBlue}>4</NumberIcon>&nbsp;
          <NumberIcon className={numberBlue}>7</NumberIcon> from blog post 1
        </div>
        <div>Tweets&nbsp;
          <NumberIcon className={numberGreen}>2</NumberIcon>&nbsp;
          <NumberIcon className={numberBlue}>5</NumberIcon>&nbsp;
          <NumberIcon className={numberBlue}>8</NumberIcon> from blog post 2
        </div>
        <div>Tweets&nbsp;
          <NumberIcon className={numberGreen}>3</NumberIcon>&nbsp;
          <NumberIcon className={numberBlue}>6</NumberIcon>&nbsp;
          <NumberIcon className={numberBlue}>9</NumberIcon> from blog post 3
        </div>
      </div>
    </div>
  </div>
</div>

export default ContentScheduleDiagram
